<template>
  <div class="products-from-list">
    <ul>
      <li 
        v-for="(product, index) of list"
        :key="index"
        class="glaxi-menu__search__content__li">
        <router-link :to="{ name: `${lang}.single-product`, params: { slug: product.fields.slug } }">
          <img
            :src="product.fields.productThumbnail.fields.file.url"
            :alt="product.fields.productThumbnail.fields.description"
            :width="product.fields.productThumbnail.fields.file.details.image.width"
            :height="product.fields.productThumbnail.fields.file.details.image.height"
            class="glaxi-menu__search__content__li__img">
          <p v-html="product.fields.title"/>
          <span v-if="typeof product.fields.productCode !== 'undefined'" v-html="product.fields.productCode" />
          <SingleProductListHasTags :product="product" />
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import SingleProductListHasTags from '@/components/SingleProductListHasTags/SingleProductListHasTags.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'ProductsFromList',
  components: {
    SingleProductListHasTags
  },
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapGetters([
      'lang'
    ])
  }
}
</script>

<style lang="scss">
  @import "./productsList.scss";
</style>
